import React from 'react';
import TermsConditions from 'components/TermsConditions';
import PrivacyPolicy from 'components/PrivacyPolicy';
import ResponsiblePolicy from 'components/ResponsiblePolicy';

export default () => (
  <div className="modalContainer modalContainer--public">
    <TermsConditions isPublic />
    <PrivacyPolicy isPublic />
    <ResponsiblePolicy isPublic />
  </div>
);
